import Order from ".";
import Checkout from "../events/Checkout";
import AddAttendees from "./AddAttendees";
import AttendeeManage from "./AttendeeManage";
import OrderList from "./OrderList";
import TicketsOrderList from "./TicketsOrderList";
import UserOrderTicket from "./UserOrderTicket";

export const orderUserRoutes = (data) => {
  return [
    {
      path: "/:lang/tickets-order",
      title: "Order Tickets",
      layout: "front",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: TicketsOrderList,
    },
    // {
    //   path: "/:lang/tickets-order/:orderId",
    //   title: "Order Tickets",
    //   layout: "front",
    //   routeType: data?.user?.role||"user",
    //   component: UserOrderTicket,
    // },
    {
      path: "/:lang/ticket-buyer",
      title: "Attendee Information",
      layout: "user",
      routeType: ["user", "organization"].includes(data?.user?.role)
        ? data?.user?.role
        : "user",
      component: AttendeeManage,
    },
    {
      path: "/:lang/user/order",
      title: "order",
      layout: "user",
      routeType: "organization",
      component: Order,
    },
    {
      path: "/:lang/user/myEvent/:eventId/attendees-add",
      title: "Add Attendees",
      layout: "frontUserInner",
      routeType: "organization",
      component: AddAttendees,
    },

    {
      path: "/:lang/user/myEvent/order/:eventId/:orderType",
      title: "order",
      layout: "frontUserInner",
      routeType: "organization",
      component: OrderList,
    },
    {
      path: "/:lang/user/checkout/:eventId",
      title: "Checkout",
      layout: "user",
      routeType: "organization",
      component: Checkout,
    },
  ];
};
